<template>
    <div>
        <AdaButton title="Filter" @click="openFilterDialog" icon="filter" :unicon="true"
                   :custom-styles="{minWidth: 'fit-content'}"></AdaButton>
        <Dialog :show="showFilterDialog" @close="showFilterDialog = false" :show-close-button="true"
                @keyup.esc="showFilterDialog = false" id="filterDialog">
            <div class="content" style="width:100%;">
                <h3 style="margin-top: 0">Filtereinstellungen</h3>
                <div style="min-height:20vh;" v-if="loading">
                    <ClipLoader color="#394956" class="loader"></ClipLoader>
                </div>
                <div v-else>
                    <div style="min-height:220px;">
                        <div class="row">
                            <Dropdown label="Spalte auswählen" :delete-selected="false"
                                      :items="columns" :select-on-click="true"
                                      @enter="columnSelected" width="200px"
                                      item-name="display_name"
                                      :style="{marginBottom:'20px', marginRight:'1rem'}"></Dropdown>
                            <Dropdown
                                :label="currentSelectedColumn && (currentSelectedColumn.name === 'start' || currentSelectedColumn.name === 'end') ? 'Spezifisches Datum auswählen' : 'Wert auswählen'"
                                :delete-selected="false"
                                :items="getFilterData(currentSelectedColumn ? currentSelectedColumn.name : null)"
                                itemName="display_name"
                                :select-on-click="true" :disabled="currentSelectedColumn === null"
                                :key="currentSelectedColumn ? currentSelectedColumn.name+'_value' : getRandomString()"
                                @enter="itemSelected($event)" flex-grow="1" width="300px"
                                :style="{marginBottom:'20px'}"></Dropdown>
                            <transition name="fade" mode="out-in">
                                <div
                                    v-if="currentSelectedColumn && (currentSelectedColumn.name === 'start' || currentSelectedColumn.name === 'end')"
                                    style="display: flex; align-items: center; margin-bottom:20px; flex-grow:1">
                                    <div class="filterName"
                                         style="margin-right:0.3rem; min-width:calc(200px + .7rem); text-align: right;">
                                        oder
                                    </div>
                                    <div style="display:flex; width:100%">
                                        <Dropdown label="Jahr" :delete-selected="false"
                                                  :items="getAllFilterYears()" :select-on-click="true"
                                                  :disabled="currentSelectedColumn === null"
                                                  :key="currentSelectedColumn ? currentSelectedColumn.name+'_year' : getRandomString()"
                                                  @enter="yearSelected($event)" flex-grow="1" width="150px"
                                                  :style="{marginRight:'1rem', marginBottom: '0'}"></Dropdown>
                                        <Dropdown label="Monat" :delete-selected="false"
                                                  :items="months" :select-on-click="true"
                                                  :key="currentSelectedYear ? currentSelectedYear.name+'_month' : getRandomString()"
                                                  :disabled="currentSelectedYear === null"
                                                  item-name="display_name"
                                                  style="margin-bottom: 0" @enter="monthSelected($event)" flex-grow="1"
                                                  width="200px"
                                        ></Dropdown>
                                    </div>
                                </div>
                            </transition>
                        </div>
                        <div v-if="selectedFilter.length === 0" class="noFilter">Keine Filter ausgewählt</div>
                        <div>
                            <div class="row filterWrapper" v-for="(filterItem, i) in selectedFilter"
                                 :key="'filterRow_'+i+getRandomString()">
                                <div class="filterName">{{ filterItem.filter.display_name }}</div>
                                <div class="filterValues">
                                    <InfoBubble v-for="(value, j) in filterItem.display_values"
                                                :key="filterItem.filter.name+'_'+j+getRandomString()"
                                                :is-filled="false" :value="value" color="blue"
                                                @bubbleDeleted="filterValueDeleted($event, filterItem)"></InfoBubble>
                                </div>
                                <unicon v-tooltip.top="filterItem.filter.display_name + ' Filter löschen'"
                                        class="filterDelete" name="trash-alt" fill="crimson"
                                        @click="deleteFilter(filterItem.filter.name)"></unicon>

                            </div>
                        </div>
                    </div>
                    <div class="button_container">
                        <AdaButton title="Filter anwenden" @click="saveFilter" :loading="saveLoading"
                                   style="margin: 1rem 1rem 0 0"></AdaButton>
                        <div style="display: flex;">
                            <AdaButton type="grey" title="Abbrechen" @click="showFilterDialog = false;"
                                       style="margin: 1rem 1rem 0 0"></AdaButton>
                            <AdaButton type="purple" title="Zurücksetzen" @click="resetFilter"
                                       style="margin: 1rem 1rem 0 0"></AdaButton>
                        </div>
                    </div>
                </div>
            </div>
        </Dialog>
    </div>
</template>

<script>
import Dialog from "@/components/dialogs/Dialog";
import AdaButton from "@/components/buttons/AdaButton";
import {RepositoryFactory} from "@/scripts/RepositoryFactory";
import Dropdown from "@/components/inputs/DropDown";
import InfoBubble from "@/components/inputs/InfoBubble";
import Vue from "vue";


const DeallistRepository = RepositoryFactory.get('deallist');
export default {
    name: "DeallistFilter",
    components: {InfoBubble, Dropdown, AdaButton, Dialog},
    data: () => ({
        showFilterDialog: false,
        filterData: null,
        loading: null,
        saveLoading: null,
        currentSelectedColumn: null,
        currentSelectedYear: null,
        currentSelectedMonth: null,
        months: [
            {name: 1, display_name: 'Januar', short: 'Jan'},
            {name: 2, display_name: 'Februar', short: 'Feb'},
            {name: 3, display_name: 'März', short: 'Mär'},
            {name: 4, display_name: 'April', short: 'Apr'},
            {name: 5, display_name: 'Mai', short: 'Mai'},
            {name: 6, display_name: 'Juni', short: 'Jun'},
            {name: 7, display_name: 'Juli', short: 'Jul'},
            {name: 8, display_name: 'August', short: 'Aug'},
            {name: 9, display_name: 'September', short: 'Sep'},
            {name: 10, display_name: 'Oktober', short: 'Okt'},
            {name: 11, display_name: 'November', short: 'Nov'},
            {name: 12, display_name: 'Dezember', short: 'Dez'},
        ]
    }),
    async mounted() {
        await this.getFilter();
        if (JSON.stringify(this.finalFilter) !== JSON.stringify(this.selectedFilter)) {
            this.$store.commit('deallist/updateSelectedFilter', {
                data: this.finalFilter,
                archived: this.$attrs.onlyArchived
            })
        }
    },
    computed: {
        selectedFilter() {
            return this.$attrs.onlyArchived ? this.$store.state.deallist.selectedFilterArchived : this.$store.state.deallist.selectedFilter;
        },
        finalFilter() {
            return this.$attrs.onlyArchived ? this.$store.state.deallist.finalFilterArchived : this.$store.state.deallist.finalFilter;
        },
        columns() {
            return this.$store.state.deallist.columns; //.filter(x => x.name !== "start" && x.name !== "end");
        }
    }
    ,
    methods: {
        openFilterDialog() {
            this.showFilterDialog = true;
        }
        ,
        async getFilter() {
            this.loading = true;
            let {data} = await DeallistRepository.getFilter(this.$attrs.onlyArchived ? 1 : 0);
            if (data.status) {
                this.filterData = data.filter;
            }
            this.$store.commit('deallist/updateSelectedFilter', {
                data: [],
                archived: this.$attrs.onlyArchived
            });
            this.loading = false;
        }
        ,
        saveFilter() {
            this.$store.commit('deallist/updateFinalFilter', {
                data: this.selectedFilter,
                archived: this.$attrs.onlyArchived
            });
            this.showFilterDialog = false;
            this.$emit('applyFilter');
        },
        columnSelected(column) {
            this.currentSelectedColumn = column;
        }
        ,
        yearSelected(data) {
            this.currentSelectedYear = data;
            this.itemSelected(data, 'year');
        }
        ,
        monthSelected(data) {
            this.currentSelectedMonth = data;
            this.itemSelected(data, 'month');
        }
        ,
        itemSelected(data, type = null) { //type = year or month -> necessary for start and end col
            if (typeof data.edited !== "undefined") {
                Vue.noty.error('Eintrag existiert nicht.');
            } else if (this.currentSelectedColumn) {
                let tmpFilter = JSON.parse(JSON.stringify(this.selectedFilter));
                let existingFilter = tmpFilter.find(x => x.filter.name === this.currentSelectedColumn.name);
                //if filter doesn't exist -> create
                if (typeof existingFilter === "undefined") {
                    tmpFilter.push({
                        filter: this.currentSelectedColumn,
                        values: [],
                        display_values: [],
                    });
                    existingFilter = tmpFilter.find(x => x.filter.name === this.currentSelectedColumn.name);
                }

                //ADD VALUE TO FILTER

                //add years and months for dates (start,end) filter

                let hasChanged = false;
                if (type) {
                    if (typeof existingFilter.years === "undefined") {
                        existingFilter.years = {};
                    }
                    if (type === 'year' && typeof existingFilter.years[data.name] === "undefined") {
                        existingFilter.years[data.name] = [];
                        existingFilter.display_values.push(data.name);
                        existingFilter.values.push('ignore');
                        hasChanged = true;
                    } else if (type === 'month' &&
                        typeof existingFilter.years[this.currentSelectedYear.name] !== "undefined" &&
                        !existingFilter.years[this.currentSelectedYear.name].includes(data.name)
                    ) {
                        existingFilter.years[this.currentSelectedYear.name].push(data.name);
                        let index = existingFilter.display_values.findIndex(x => x.indexOf(this.currentSelectedYear.name) !== -1);
                        let shorts = existingFilter.years[this.currentSelectedYear.name].map(x => this.months.find(y => y.name === x).short);
                        existingFilter.display_values[index] = this.currentSelectedYear.name + ' (' + shorts.join(',') + ')';
                        hasChanged = true;
                    } else {
                        this.$noty.warning('Eintrag schon ausgewählt');
                    }
                    if (hasChanged) {
                        this.$store.commit('deallist/updateSelectedFilter', {
                            data: tmpFilter,
                            archived: this.$attrs.onlyArchived
                        });
                    }
                } else {

                    //add everything else to the filter

                    if (!existingFilter.values.includes(data.name)) {
                        existingFilter.values.push(data.name);
                        //show date als readable date and null as (leer) except for 'end' is 'always on'
                        let tmpValue = this.currentSelectedColumn.name === 'end' || this.currentSelectedColumn.name === 'start' ?
                            (data.name !== "null" ? this.moment(data.name).format('DD.MM.YYYY') : data.name) : data.name;
                        existingFilter.display_values.push(tmpValue === "null" ? (this.currentSelectedColumn.name === "end" ? "always on" : "(leer)") : tmpValue);
                        this.$store.commit('deallist/updateSelectedFilter', {
                            data: tmpFilter,
                            archived: this.$attrs.onlyArchived
                        });
                    } else {
                        this.$noty.warning('Eintrag schon ausgewählt');
                    }
                }
            }
        },
        getFilterData(col = null) {
            let ret = []
            if (col) {
                if (col !== "id") ret.push({name: 'null', display_name: col === "end" ? 'always on' : '(leer)'})
                this.filterData[col].forEach((x) => {
                    if (x) {
                        if (col === "start" || col === "end") {
                            ret.push({name: x, display_name: this.moment(x).format('DD.MM.YYYY')})
                        } else {
                            ret.push({name: x, display_name: x})
                        }
                    }
                });
            }
            return ret;
        },
        getAllFilterYears() {
            let ret = [];
            if (this.currentSelectedColumn) {
                let items = this.getFilterData(this.currentSelectedColumn.name);
                for (let i = 0; i < items.length; i++) {
                    if (items[i].name !== "null") {
                        let splittedDate = items[i].display_name.split('.');
                        let year = splittedDate[splittedDate.length - 1];
                        if (year !== "Invalid date" && !ret.includes(year)) {
                            ret.push(year);
                        }
                    }
                }
                ret.sort(function (a, b) {
                    return b - a;
                });
            }
            return ret.map((x) => {
                return {name: x, display_name: x}
            });
        },
        filterValueDeleted(value, filterItem) {
            let tmpFilter = JSON.parse(JSON.stringify(this.selectedFilter));
            let tmpFilterItem = tmpFilter.find(x => x.filter.name === filterItem.filter.name);
            let valueIndex = tmpFilterItem.display_values.findIndex(x => x === value);
            tmpFilterItem.values.splice(valueIndex, 1);
            tmpFilterItem.display_values.splice(valueIndex, 1);
            this.$store.commit('deallist/updateSelectedFilter', {
                data: tmpFilter,
                archived: this.$attrs.onlyArchived
            });
            if (tmpFilterItem.values.length === 0) {
                this.deleteFilter(tmpFilterItem.filter.name);
            }
        },
        deleteFilter(filtername) {
            let tmpFilter = JSON.parse(JSON.stringify(this.selectedFilter));
            tmpFilter.splice(tmpFilter.findIndex(x => x.filter.name === filtername), 1);
            this.$store.commit('deallist/updateSelectedFilter', {
                data: tmpFilter,
                archived: this.$attrs.onlyArchived
            });
        },
        getRandomString() {
            return (Math.random() + 1).toString(36).substring(7);
        },
        resetFilter() {
            this.$store.commit('deallist/updateSelectedFilter', {
                data: [],
                archived: this.$attrs.onlyArchived
            });
        }
    }
    ,
}
</script>

<style lang="scss" scoped>
:deep( #filterDialog .modal-container) {
    width: 700px !important;
    max-width: 1200px !important;
    max-height: 80vh;

    .content {
        overflow: auto;
    }
}

:deep(.o-date-list__item ){
    padding-left: 1rem;
    text-align: left;
}

:deep(.button_container) {
    display: flex;
    flex-flow: row;
    justify-content: space-between !important;
    margin-top: 2rem;

    button {
        height: 2.2em;
    }

}

.row {
    display: flex;
    flex-flow: wrap;
}

.noFilter {
    height: 150px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-transform: uppercase;
    font-weight: 600;
    color: #546E7A;
    font-size: 0.9rem;
}

.filterName {
    padding: 3px 10px 0 10px;
    text-transform: uppercase;
    font-size: 0.8rem;
    font-weight: 600;
    min-width: 150px;
    color: #546E7A;
}

.filterWrapper {
    display: flex;
    flex-flow: wrap;
    width: 100%;
    margin: 0.3rem 0;
    padding: 8px 0 4px 0;

    &:nth-child(odd) {
        background: #ECEFF1;
    }


    .filterValues {
        position: relative;
        top: 1px;
        width: 450px;
    }

    .filterDelete {
        display: flex;
        justify-self: end;
        font-weight: 400;
    }

    .infoBubble {
        word-break: break-all;
    }
}
</style>